export default {"src":"/_next/static/media/left-slider-arrow.daab335e.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};